import React, { useEffect, useState } from 'react'
import CustomInput from "Utills/CustomInput/CustomInput"
import { DateRangePicker } from "react-date-range";
import { useHistory } from "react-router-dom";
import CustomModel from "Utills/Model/CustomModel"
import Moment from "moment"
import axios from "axios";
import { useNotifyContext } from "context/notifyContext"
import { Close, DoneAll, DeleteForever } from "@material-ui/icons";
import CustomModal from "Utills/Model/CustomModel";
import { v4 as uuidv4 } from 'uuid';

// Get User Token
let storeData = localStorage.getItem("cyan_user");
// PArse the token
let userToken = storeData ? JSON.parse(storeData) : "";
//  Aoi domain to embed with every image url
let apiStart = process.env.REACT_APP_API_DOMAIN;
let initialId = uuidv4();
// =============== APi endpoints ===============
let allInclusiveImages_API =  process.env.REACT_APP_ALL_INCLUSIVE_IMAGES;
let allInclusive_API =  process.env.REACT_APP_ALL_INCLUSIVE_OFFERS_ADMIN;


// ============ Initial form fields =================
const initial = {
    imgTemplate: 0,
    mainTitle: "",
    guests: 1,
    boat_beds: 1,
    boat_bathrooms: 1,
    boat_length: 1,
    price: "",
    counter: 1,
    duration: 1,
    overnight: false,
    offerVisible: false,
    general_description: "",
    amenities: "",
    extras: "",
    departure_location: "",
    transfer_description: "",
    island_1: "",
    island_2: "",
    island_3: "",
    island_4: "",
    island_5: "",
    brief_description: "",
    first_description: "",
    second_description: "",
    yacht_title: "",
    yacht_description: "",
    transfer_title: "",
    activity_title_1: "",
    activity_title_2: "",
    primary_img: {
        file: null,
        isSelected: false,
    },
    first_activity_img: {
        file: {},
        isSelected: false,
    },
    second_activity_img: {
        file: {},
        isSelected: false,
    },
    boat_img: {
        [initialId]: {
            file: {},
            isSelected: false,
            id: initialId
        }
    },
    transfer_img: {
        file: {},
        isSelected: false,
    },
};


// Add New offer page
const AddNew = () => {
    const history = useHistory();
    // notification
    const { set_notify, set_loader } = useNotifyContext();
    const [formData, setFormData] = useState(initial);
    const [dateState, setDateState] = useState([
        {
            startDate: new Date(),
            endDate: new Date(),
            key: 'selection',
        },
    ]);
    const [pickupDateModal, setPickupCalendar] = useState(false);
    const [selectedImgFromGallery, setSelectedImgFromGallery] = useState(false);
    const [imgModal, setImgModal] = useState({ open: false, type: "" });
    const [allOffersImgs, setAllOffersImgs] = useState([])
    const [newImgFile, setNewImgFile] = useState({ file: null, isSelected: false, name: "" })

    // 
    // get data ======== for development purpose ====================
    const get_Images_data = () => {
        let url = allInclusiveImages_API;
        axios.get(url, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Token ${userToken}`
            }
        }).then((response) => {
            let data = response.data
            if (data?.status !== "error") {
                setAllOffersImgs(data?.pictures)
            }
        }).catch((err) => {
            console.log("Error ====>", err.message);
        })
    };
    // =========== get all the inclusive offers uploaded images from api
    useEffect(() => {
        get_Images_data();
        return () => {
            get_Images_data()
        }
    }, [])

    // offer image templates array
    // const imgTemplates = [
    //     {
    //         id: 0, name: "sampleOne", template:
    //             <>
    //                 <div className="imgTemplate_col">1</div>
    //                 <div className="imgTemplate_col">2</div>
    //                 <div className="imgTemplate_col">3</div>
    //             </>
    //     },
    //     {
    //         id: 1, name: "sampleTwo", template:
    //             <>
    //                 <div className="imgTemplate_col">1</div>
    //                 <div className="imgTemplate_separate">
    //                     <div className="imgTemplate_col">2</div>
    //                     <div className="imgTemplate_col">3</div>
    //                 </div>
    //             </>
    //     },
    //     {
    //         id: 2, name: "sampleThree", template:
    //             <>
    //                 <div className="imgTemplate_col">1</div>
    //                 <div className="imgTemplate_col">2</div>
    //                 <div className="imgTemplate_col">3</div>
    //             </>
    //     },
    // ];

    // 
    const get_Image_Id = (r) => {
        return Object.keys(allOffersImgs).find(k => allOffersImgs[k] === r);
    };

    // ====================== Upload New Offer ======================
    const upload_new_offer = async () => {
        set_loader(true)
        let all_inclusive_images_url = allInclusiveImages_API;
        let all_inclusive_url = allInclusive_API;
        // 

        //==========  ignore ====================
        // let files_to_upload = [
        //     { file: formData?.primary_img?.file, type: 'general' },
        //     { file: formData?.first_activity_img?.file, type: 'activity' },
        //     { file: formData?.second_activity_img?.file, type: 'activity' },
        //     { file: formData?.boat_img?.file, type: 'boat' },
        //     { file: formData?.transfer_img?.file, type: 'transfer' },
        // ];
        // const general_imgs = [];
        // const activity_imgs = [];
        // const boat_imgs = [];
        // const transfer_imgs = [];
        //=============== Upload images =============
        // const uploadFile = (file, type) => {
        //     return new Promise((resolve, reject) => {
        //         let imageFile = new FormData();
        //         imageFile.append('image', file);
        //         // 
        //         axios.post(all_inclusive_images_url, imageFile, { headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Token ${userToken}` } }).then((response) => {
        //             let data = response?.data;
        //             if (data.status !== "error") {
        //                 // return reject({ id: data?.id, type: type });
        //                 switch (type) {
        //                     case 'general':
        //                         general_imgs.push(data?.id);
        //                         return resolve()
        //                         break;
        //                     case 'activity':
        //                         activity_imgs.push(data?.id);
        //                         return resolve()
        //                         break;
        //                     case 'boat':
        //                         boat_imgs.push(data?.id);
        //                         return resolve()
        //                         break;
        //                     case 'transfer':
        //                         transfer_imgs.push(data?.id);
        //                         return resolve()
        //                         break;
        //                 }
        //             } else {
        //                 set_loader(false);
        //                 set_notify({ open: true, msg: data?.['error-message'], type: "error" });
        //                 console.log("Error from upload file ====>", data);
        //                 return reject();
        //             }
        //         }).catch((err) => {
        //             console.log("Error ====>", err.message);
        //             set_notify({ open: true, msg: err?.message, type: "error" });
        //             set_loader(false);
        //             return reject()
        //         })
        //     })
        // };


        const postToAPI = () => {
            let dataA = {
                'title': formData?.mainTitle,
                'price': formData?.price,
                'overnight': formData?.overnight ? 'true' : 'false',
                'itinerary': formData?.island_1 + "," + formData?.island_2 + "," + formData?.island_3 + "," + formData?.island_4 + "," + formData?.island_5,
                'duration': formData?.duration,
                'amenities': formData?.amenities,
                'extras': formData?.extras,
                'availability_start_date': Moment(dateState[0]?.startDate?.toString()).format('YYYY-MM-DD'),
                'availability_end_date': Moment(dateState[0]?.endDate?.toString()).format('YYYY-MM-DD'),
                'checkin_hour': 1,
                'checkout_hour': 1,
                'thumbnail': get_Image_Id(formData?.primary_img?.file),
                'location': formData?.departure_location,
                'exact_location': formData?.departure_location,
                'available': formData?.offerVisible ? 'true' : 'false',
                'counter': formData?.counter,
                'num_of_people': formData.guests,
                'boat_beds':  parseInt(formData.boat_beds),
                'boat_bathrooms':  parseInt(formData.boat_bathrooms),
                'boat_length':  parseInt(formData.boat_length),
                'brief_description': formData?.brief_description,
                'general_description': formData?.general_description,
                'boat_title': formData?.yacht_title,
                'boat_description': formData?.yacht_description,
                'activities_titles': formData?.activity_title_1 + "," + formData?.activity_title_2,
                'transfer_title': formData?.transfer_title,
                'activities_descriptions': [formData?.first_description, formData?.second_description],
                'transfer_description': formData?.transfer_description,
                'general_pictures': [Number(get_Image_Id(formData?.primary_img?.file))],
                'boat_pictures': [
                    ...Object.values(formData?.boat_img)?.map((s) => (Number(get_Image_Id(s.file))))
                ],
                'activities_pictures': [Number(get_Image_Id(formData?.first_activity_img?.file)), Number(get_Image_Id(formData?.second_activity_img?.file))],
                'transfer_pictures': [Number(get_Image_Id(formData?.transfer_img?.file))],
            };
            axios.post(all_inclusive_url, dataA, {
                headers: {
                    'Content-Type': 'application/json; charset=utf-8', // "text/html; charset=UTF-8",
                    'Authorization': `Token ${userToken}`,
                }
            }).then((response) => {
                let data = response?.data;
                if (data.status !== "error") {
                    // console.log("New Offer Uploaded Successfully", response)
                    set_notify({ open: true, msg: "New Inclusive Offer posted successfully", type: "success" })
                    setFormData(initial)
                    setDateState([
                        {
                            startDate: new Date(),
                            endDate: new Date(),
                            key: 'selection',
                        },
                    ]);
                    set_loader(false);
                    setTimeout(() => {
                        history.push('/dashboard/offers/allInclusive');
                    }, 500)
                } else {
                    set_loader(false);
                    set_notify({ open: true, msg: data?.['error-message'], type: "error" })
                    console.log("Error when posting new offer ====>", data);
                }
            }).catch((err) => {
                console.log("Error  ====>", err.message);
                set_notify({ open: true, msg: err?.message, type: "error" })
                set_loader(false)
            })
        }

        postToAPI();

        // ================= Ignore this for now =========================================
        // Promise.all(files_to_upload.map(function (v, i) {
        //     return uploadFile(v.file, v.type).then((response) => {
        //         // ========================
        //         // set_notify({ open: true, msg: "All the Images uploaded successfully", type: "success" });
        //         // console.log(response)
        //         // switch (response.type) {
        //         //     case 'general':
        //         //         general_imgs.push(response.id)
        //         //         break;
        //         //     case 'activity':
        //         //         activity_imgs.push(response.id)
        //         //         break;
        //         //     case 'boat':
        //         //         boat_imgs.push(response.id)
        //         //         break;
        //         //     case 'transfer':
        //         //         transfer_imgs.push(response.id)
        //         //         break;
        //         // }
        //         // ============================
        //         if (i + 1 === files_to_upload.length) {
        //             setTimeout(() => {
        //                 set_loader(false)
        //                 console.log("-----------------")
        //                 console.log(general_imgs)
        //                 console.log(boat_imgs)
        //                 console.log(activity_imgs)
        //                 console.log(transfer_imgs)
        //                 postToAPI();
        //             }, 500)
        //         }
        //     })
        // }))
        // ============================================
    };

    // get data ======== for development purpose ====================
    // const get_data = () => {
    //     // let url = allInclusiveImages_API;
    //     let url = allInclusive_API;
    //     axios.get(url, {
    //         headers: {
    //             'Content-Type': 'multipart/form-data',
    //             'Authorization': `Token ${userToken}`
    //         }
    //     }).then((response) => {
    //         console.log("res ====>", response);
    //     }).catch((err) => {
    //         console.log("Error ====>", err.message);
    //     })
    // }


    //================ select new image from user device ====================
    const selectNewImg = (e) => {
        let files = e.target?.files;
        const fileSize = files[0]?.size / 1024 / 1024; // in MiB
        if (files[0]?.length !== 0) {
            // const url = URL.createObjectURL(e?.target?.files[0]);
            // setFormData({
            //     ...formData,
            //     [key_name]: {
            //         file: e?.target?.files[0],
            //         isSelected: true,
            //     }
            // })
            if (fileSize <= 1) {
                setNewImgFile({
                    file: files[0],
                    isSelected: true,
                    name: files[0]?.name
                })
            } else {
                set_notify({ open: true, msg: "File Size is max then 1 MB", type: "error" })
            }
        } else {
            set_notify({ open: true, msg: "File can not read!", type: "error" })
        }
    };
    //====================== remove selected image =========================
    const removeSelectedImg = (e, key_name, multiples) => {
        // console.log("=======>", key_name, multiples)
        if (multiples) {
            setFormData({
                ...formData,
                boat_img: {
                    ...formData.boat_img,
                    [key_name]: {
                        file: null,
                        isSelected: false,
                        id: key_name
                    }
                }
            })
        } else {
            setFormData({
                ...formData,
                [key_name]: {
                    file: null,
                    isSelected: false,
                }
            })
        }
    };

    // ===================== handle form inputs onChange ====================
    const handlePersonalForm = (e) => {
        let { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        })
    };

    const checkAllImage = () => {
        let fields_to_check = ['primary_img', 'first_activity_img', 'second_activity_img', 'transfer_img'];
        let l = fields_to_check?.filter((v) => formData[v]?.isSelected === false);
        // console.log(l)
        return l.length === 0 && Object.values(formData?.boat_img).length > 0 && Object.values(formData?.boat_img)?.filter((v) => v?.isSelected === true).length > 0 ? false : true;
    };

    const upload_new_img_to_DB = () => {
        set_loader(true);
        let all_inclusive_images_url = allInclusiveImages_API;
        let imageFile = new FormData();
        imageFile.append('image', newImgFile?.file);
        // 
        axios.post(all_inclusive_images_url, imageFile, { headers: { 'Content-Type': 'multipart/form-data', 'Authorization': `Token ${userToken}` } }).then((response) => {
            let data = response?.data;
            if (data.status !== "error") {
                set_loader(false);
                set_notify({ open: true, msg: "Image uploaded successfully!", type: "success" });
                setNewImgFile({ name: "", file: "", isSelected: false });
                get_Images_data()
            } else {
                set_loader(false);
                set_notify({ open: true, msg: data?.['error-message'], type: "error" });
                console.log("Error from upload file ====>", data);
            }
        }).catch((err) => {
            console.log("Error ====>", err.message);
            set_notify({ open: true, msg: err?.message, type: "error" });
            set_loader(false);
        })
    }

    // scroll in to view for selected image from modal popup
    useEffect(() => {
        let d = document.querySelector('.selected_img_from_db');
        if (d) {
            d?.scrollIntoView({ behavior: "smooth", block: "center", inline: "nearest" });
        }
    }, [selectedImgFromGallery, imgModal]);

    // 
    const setImageInForm = () => {
        if (imgModal.multiples) {
            setFormData({
                ...formData,
                boat_img: {
                    ...formData.boat_img,
                    [imgModal?.type]: {
                        id: imgModal?.type,
                        file: selectedImgFromGallery,
                        isSelected: true,

                    }
                }
            });

        } else {
            setFormData({ ...formData, [imgModal?.type]: { file: selectedImgFromGallery, isSelected: true } });
        }
        setImgModal({ open: false, type: '' });
        setSelectedImgFromGallery(null)
    };

    // 
    const deleteSelectedImageFromArray = (num) => {
        let s = Object.values(formData.boat_img).filter(v => v.id !== num);
        if (s.length > 0) {
            let obj = {};
            s.map((d, i) => {
                obj = {
                    ...obj,
                    [d.id]: d
                }
            });
            setFormData({
                ...formData,
                boat_img: obj
            });
        }
    };

    // add new 
    const addNewButton = () => {
        let newId = uuidv4();
        if (Object.values(formData?.boat_img)?.length < 15) {
            setFormData({
                ...formData,
                boat_img: {
                    ...formData.boat_img,
                    [newId]:
                    {
                        isSelected: false,
                        file: {},
                        id: newId
                    }
                }
            });
        }
    };

    return (
        <div className="py-3">
            <CustomModal openPopup={imgModal?.open} setOpenPopup={() => { setImgModal({ open: false, type: '' }); setSelectedImgFromGallery(null) }}>
                <div className="modal-body all_offers_uploaded_imgs_modal_body p-0 text-center">
                    <div className="all_offers_images_modal_header">
                        <h4>Select Image</h4>
                        <p>Select from saved images or upload new</p>
                        <p className="text-dark">Images found: ({Object.values(allOffersImgs)?.length})</p>
                    </div>

                    <div className="d-flex flex-wrap all_offers_uploaded_imgs_row">
                        {Object.values(allOffersImgs)?.reverse()?.map((item, i) => (
                            <div id={i} className={`static_img_select_btn modal_imgs 
                            ${selectedImgFromGallery === item ? ' selected_img_from_db' : ""}`}
                                onClick={() => setSelectedImgFromGallery(item)}>
                                <div className="static_img_select_wrap position-relative">
                                    <img loading="lazy" width="100" height="100" src={apiStart + item} alt="" />
                                    {selectedImgFromGallery === item &&
                                        <>
                                            <svg className="selected_img_from_db_icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                                <path className="choose-img-btn-camera" d="M8 15L3 10L4.41 8.58L8 12.17L15.59 4.58L17 6L8 15ZM10 0C8.68678 0 7.38642 0.258658 6.17317 0.761205C4.95991 1.26375 3.85752 2.00035 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C3.85752 17.9997 4.95991 18.7362 6.17317 19.2388C7.38642 19.7413 8.68678 20 10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 8.68678 19.7413 7.38642 19.2388 6.17317C18.7362 4.95991 17.9997 3.85752 17.0711 2.92893C16.1425 2.00035 15.0401 1.26375 13.8268 0.761205C12.6136 0.258658 11.3132 0 10 0Z" fill="#3F8BBF" />
                                            </svg>
                                        </>}
                                </div>
                            </div>
                        ))}
                    </div>
                    <div className="mt-2 w-100 all_offers_images_modal_footer py-2 px-3 d-flex flex-wrap align-items-center justify-content-between">
                        {newImgFile?.isSelected ?
                            <div>
                                <p className="text-pr d-flex align-items-center"><Close onClick={() => setNewImgFile({ isSelected: false, file: "", name: "" })} className="bg-danger rounded rounded-circle cursor-pointer me-2 text-white p-1 " /> Selected File: <span className="text-sec"> {newImgFile?.name}</span></p>
                                <button onClick={upload_new_img_to_DB} className="dark-btn book_now_btn  mt-2 text-white cursor-pointer">
                                    <DoneAll className="me-1" />
                                    Save
                                </button>
                            </div>

                            :
                            <label htmlFor="newImg" className="dark-btn book_now_btn  mt-2 text-white cursor-pointer">
                                <svg className="me-1" width="19" height="14" viewBox="0 0 19 14" fill="none">
                                    <path d="M12.1155 7.49991C12.1155 8.26497 11.8116 8.9987 11.2706 9.53968C10.7297 10.0807 9.99593 10.3846 9.23087 10.3846C8.4658 10.3846 7.73207 10.0807 7.19109 9.53968C6.65011 8.9987 6.34619 8.26497 6.34619 7.49991C6.34619 6.73485 6.65011 6.00112 7.19109 5.46014C7.73207 4.91915 8.4658 4.61523 9.23087 4.61523C9.99593 4.61523 10.7297 4.91915 11.2706 5.46014C11.8116 6.00112 12.1155 6.73485 12.1155 7.49991Z" fill="white" />
                                    <path d="M2.30774 2.30774C1.69569 2.30774 1.10871 2.55088 0.675921 2.98366C0.243136 3.41645 0 4.00343 0 4.61548L0 11.5387C0 12.1507 0.243136 12.7377 0.675921 13.1705C1.10871 13.6033 1.69569 13.8464 2.30774 13.8464H16.1542C16.7662 13.8464 17.3532 13.6033 17.786 13.1705C18.2188 12.7377 18.4619 12.1507 18.4619 11.5387V4.61548C18.4619 4.00343 18.2188 3.41645 17.786 2.98366C17.3532 2.55088 16.7662 2.30774 16.1542 2.30774H14.8018C14.1898 2.30761 13.603 2.06439 13.1703 1.63157L12.2149 0.676168C11.7822 0.243353 11.1953 0.000130704 10.5833 0H7.87862C7.26662 0.000130704 6.67974 0.243353 6.24705 0.676168L5.29165 1.63157C4.85896 2.06439 4.27208 2.30761 3.66007 2.30774H2.30774ZM2.88467 4.61548C2.73166 4.61548 2.58492 4.55469 2.47672 4.4465C2.36852 4.3383 2.30774 4.19156 2.30774 4.03854C2.30774 3.88553 2.36852 3.73879 2.47672 3.63059C2.58492 3.52239 2.73166 3.46161 2.88467 3.46161C3.03769 3.46161 3.18443 3.52239 3.29263 3.63059C3.40083 3.73879 3.46161 3.88553 3.46161 4.03854C3.46161 4.19156 3.40083 4.3383 3.29263 4.4465C3.18443 4.55469 3.03769 4.61548 2.88467 4.61548ZM13.2695 7.50015C13.2695 8.57124 12.844 9.59846 12.0866 10.3558C11.3293 11.1132 10.302 11.5387 9.23096 11.5387C8.15987 11.5387 7.13265 11.1132 6.37528 10.3558C5.6179 9.59846 5.19241 8.57124 5.19241 7.50015C5.19241 6.42906 5.6179 5.40185 6.37528 4.64447C7.13265 3.8871 8.15987 3.46161 9.23096 3.46161C10.302 3.46161 11.3293 3.8871 12.0866 4.64447C12.844 5.40185 13.2695 6.42906 13.2695 7.50015Z" fill="white" />
                                </svg>
                                Upload
                                <input className="d-none" type="file"
                                    accept="image/jpeg, image/png, image/gif, image/svg, image/jpg"
                                    name="" id="newImg"
                                    onChange={selectNewImg}
                                />
                            </label>}

                        <div className="d-flex justify-content-end">
                            <button onClick={() => { setImgModal({ open: false, type: '' }); setSelectedImgFromGallery(null) }} className="message-the-capt text-dark book_now_btn me-2 mt-2">Cancel</button>
                            <button disabled={selectedImgFromGallery === null}
                                onClick={setImageInForm}
                                className="dark-btn book_now_btn  mt-2">Okay</button>
                        </div>
                    </div>
                </div>
            </CustomModal>
            {/*  */}
            <h3>Add New Offer</h3>
            <div className="row bg-light-gray my-1">
                <div className="bg-offWhite py-2 d-flex justify-content-end align-items-center">
                    <button className="cs_btn dark-btn px-4 mx-3" onClick={upload_new_offer}
                        disabled={checkAllImage()}>Confirm</button>
                        {/* ignore */}
                    {/* <button className="cs_btn dark-btn px-4 mx-3" onClick={get_data}>Get Data</button> */}
                    <button className="cs_btn white-btn px-4" >Cancel</button>
                </div>
            </div>
            <div className="px-2 pt-2">
                {/*========= gallery template ================== */}
                {/* <div className="fw-bold">
                    <span>- Template</span> <button className="bg-none text-sec fw-bold">+ Create New</button>
                </div>
                <div className="d-flex mt-2 px-2 flex-wrap justify-c```````````````````ontent-start align-items-center">
                    {imgTemplates.map((temp, ind) => (
                        <div key={ind} onClick={() => { setFormData({ ...formData, imgTemplate: temp?.id }) }} className={`imageTemplate ${temp.name} ${temp.id === formData.imgTemplate ? 'selected_imgTemplate' : ''}`}>
                            {temp.template}
                        </div>
                    ))}
                </div> */}
                {/*  */}
                <div className="fw-bold mt-4 mb-2">
                    <span>- Gallary</span>
                </div>
                {/*=========== gallery images =========== */}
                <div className="row py-2 px-2 d-flex flex-wrap">
                    <div className="col-lg-3 col-md-4 col-6 mb-md-0 mb-3">
                        <span className="fw-bold">Thumbnail</span>
                        <div className="static_img_select_btn" >
                            <StaticImageBtn
                                formData={formData}
                                setImgModal={setImgModal}
                                setSelectedImgFromGallery={setSelectedImgFromGallery}
                                type="primary_img"
                                removeSelectedImg={removeSelectedImg}
                            />
                            {/* <div className="static_img_select_wrap" onClick={() => { setImgModal({ open: true, type: 'primary_img' }); setSelectedImgFromGallery(formData?.primary_img?.file) }}>
                                {formData?.primary_img?.isSelected ?
                                    <img src={apiStart + formData?.primary_img?.file} alt="" />
                                    :
                                    <>
                                        <svg width="39" height="34" viewBox="0 0 39 34" fill="none">
                                            <path d="M14.625 11.0625C14.625 12.0073 14.2497 12.9135 13.5816 13.5816C12.9135 14.2497 12.0073 14.625 11.0625 14.625C10.1177 14.625 9.21153 14.2497 8.54343 13.5816C7.87533 12.9135 7.5 12.0073 7.5 11.0625C7.5 10.1177 7.87533 9.21153 8.54343 8.54343C9.21153 7.87533 10.1177 7.5 11.0625 7.5C12.0073 7.5 12.9135 7.87533 13.5816 8.54343C14.2497 9.21153 14.625 10.1177 14.625 11.0625Z" fill="#92B9D5" />
                                            <path d="M5.125 0.375C3.86522 0.375 2.65704 0.875445 1.76624 1.76624C0.875445 2.65704 0.375 3.86522 0.375 5.125V28.875C0.375 30.1348 0.875445 31.343 1.76624 32.2338C2.65704 33.1246 3.86522 33.625 5.125 33.625H33.625C34.8848 33.625 36.093 33.1246 36.9838 32.2338C37.8746 31.343 38.375 30.1348 38.375 28.875V5.125C38.375 3.86522 37.8746 2.65704 36.9838 1.76624C36.093 0.875445 34.8848 0.375 33.625 0.375H5.125ZM33.625 2.75C34.2549 2.75 34.859 3.00022 35.3044 3.44562C35.7498 3.89102 36 4.49511 36 5.125V20.5625L27.0296 15.9384C26.8069 15.8268 26.5547 15.7881 26.3088 15.8277C26.0629 15.8674 25.8356 15.9834 25.6593 16.1593L16.848 24.9705L10.5305 20.762C10.3024 20.6101 10.0288 20.5418 9.75611 20.5687C9.4834 20.5955 9.22837 20.7158 9.03425 20.9093L2.75 26.5V5.125C2.75 4.49511 3.00022 3.89102 3.44562 3.44562C3.89102 3.00022 4.49511 2.75 5.125 2.75H33.625Z" fill="#92B9D5" />
                                        </svg>
                                        <svg className="choose-img-btn-camera" width="27" height="21" viewBox="0 0 27 21" fill="none">
                                            <path d="M17.8005 11.0623C17.8005 12.1682 17.3612 13.2288 16.5792 14.0108C15.7972 14.7928 14.7366 15.2321 13.6307 15.2321C12.5248 15.2321 11.4642 14.7928 10.6822 14.0108C9.90025 13.2288 9.46094 12.1682 9.46094 11.0623C9.46094 9.95645 9.90025 8.89586 10.6822 8.11387C11.4642 7.33189 12.5248 6.89258 13.6307 6.89258C14.7366 6.89258 15.7972 7.33189 16.5792 8.11387C17.3612 8.89586 17.8005 9.95645 17.8005 11.0623Z" fill="#3F8BBF" />
                                            <path d="M3.62488 3.55652C2.74016 3.55652 1.89169 3.90797 1.2661 4.53356C0.640513 5.15914 0.289063 6.00762 0.289062 6.89233L0.289063 16.8998C0.289063 17.7845 0.640513 18.633 1.2661 19.2586C1.89169 19.8841 2.74016 20.2356 3.62488 20.2356H23.6398C24.5245 20.2356 25.373 19.8841 25.9985 19.2586C26.6241 18.633 26.9756 17.7845 26.9756 16.8998V6.89233C26.9756 6.00762 26.6241 5.15914 25.9985 4.53356C25.373 3.90797 24.5245 3.55652 23.6398 3.55652H21.685C20.8003 3.55633 19.952 3.20475 19.3266 2.57912L17.9455 1.1981C17.3201 0.572467 16.4717 0.220892 15.5871 0.220703H11.6775C10.7929 0.220892 9.94455 0.572467 9.31911 1.1981L7.93809 2.57912C7.31264 3.20475 6.4643 3.55633 5.57966 3.55652H3.62488ZM4.45883 6.89233C4.23765 6.89233 4.02553 6.80447 3.86914 6.64807C3.71274 6.49168 3.62488 6.27956 3.62488 6.05838C3.62488 5.8372 3.71274 5.62508 3.86914 5.46868C4.02553 5.31229 4.23765 5.22442 4.45883 5.22442C4.68001 5.22442 4.89213 5.31229 5.04852 5.46868C5.20492 5.62508 5.29278 5.8372 5.29278 6.05838C5.29278 6.27956 5.20492 6.49168 5.04852 6.64807C4.89213 6.80447 4.68001 6.89233 4.45883 6.89233ZM19.47 11.0621C19.47 12.6103 18.855 14.0952 17.7602 15.19C16.6654 16.2847 15.1806 16.8998 13.6323 16.8998C12.0841 16.8998 10.5992 16.2847 9.50446 15.19C8.40968 14.0952 7.79465 12.6103 7.79465 11.0621C7.79465 9.51385 8.40968 8.02902 9.50446 6.93424C10.5992 5.83946 12.0841 5.22442 13.6323 5.22442C15.1806 5.22442 16.6654 5.83946 17.7602 6.93424C18.855 8.02902 19.47 9.51385 19.47 11.0621Z" fill="#3F8BBF" />
                                        </svg>
                                    </>}
                            </div>
                            {formData?.primary_img?.isSelected && <div className="remove-up-img" onClick={(e) => removeSelectedImg(e, 'primary_img')}><Close /></div>} */}
                        </div>
                        {/* <div onClick={() => setImgModal({ open: true, type: 'primary_img' })}>
                            <div className="static_btn">
                            <PickImageBtn
                                classes='thumbnail'
                                num={0}
                                template2
                                loading={false}
                                // selectImg={(e) => { selectNewImg(e, 'primary_img') }}
                                selectImg={(e) => null}
                                deleteImage={(e) => { removeSelectedImg(e, 'primary_img') }}
                                imgSrc={formData?.primary_img?.file}
                                srcAvail={formData?.primary_img?.isSelected}
                            />
                            </div>
                        </div> */}
                    </div>
                </div>
                {/*====== other information =========== */}
                <div className="fw-bold mt-4 mb-2">
                    <span>- Information</span>
                </div>
                <div className="row m-0 px-md-2">
                    {/*  */}
                    <div className="col-lg-8 col-md-10">
                        {/* title */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-center">
                            <div className="creatNewOffer_label text-left "><label htmlFor="">Title</label></div>
                            <div className="profile-inputs-wrapper">
                                <CustomInput name="mainTitle" placeholder="Enter"
                                    type="text"
                                    onChange={(e) => handlePersonalForm(e)} value={formData.mainTitle}
                                />

                            </div>
                        </div>
                        {/* type */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-center">
                            <div className="creatNewOffer_label text-left "><label htmlFor="">Type</label></div>
                            <div className="profile-inputs-wrapper">
                                <div className="d-flex mb-3 mt-1">
                                    <div className="">
                                        <label htmlFor="Intraday" className="checkbox-button">
                                            <input
                                                type="checkbox"
                                                className="checkbox-button__input"
                                                checked={!formData?.overnight} onChange={(e) => {
                                                    setFormData({
                                                        ...formData,
                                                        'overnight': false,
                                                        suggest_feature: ''
                                                    })
                                                }}
                                                id="Intraday" name="overnight" />
                                            <span className="checkbox-button__control"></span>
                                            <span className="checkbox-button__label text-sec">Intraday</span>
                                        </label>
                                    </div>
                                    <div className="mx-md-4">
                                        <label htmlFor="overnight" className="checkbox-button">
                                            <input
                                                type="checkbox"
                                                className="checkbox-button__input"
                                                checked={formData?.overnight} onChange={(e) => {
                                                    setFormData({
                                                        ...formData,
                                                        'overnight': true,
                                                        suggest_feature: ''
                                                    })
                                                }}
                                                id="overnight" name="overnight" />
                                            <span className="checkbox-button__control"></span>
                                            <span className="checkbox-button__label text-sec">Overnight</span>
                                        </label>
                                    </div>

                                </div>
                            </div>
                        </div>
                        {/* Departure Location */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-center">
                            <div className="creatNewOffer_label text-left "><label htmlFor="">Departure Location</label></div>
                            <div className="profile-inputs-wrapper">
                                <CustomInput name="departure_location" placeholder="Enter" type="text"
                                    onChange={(e) => handlePersonalForm(e)} value={formData.departure_location}
                                />
                            </div>
                        </div>
                        {/* islands */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-start">
                            <div className="creatNewOffer_label text-left "><label htmlFor="">Islands</label></div>
                            <div className="profile-inputs-wrapper flex-wrap">
                                <CustomInput name="island_1" placeholder="Enter" type="text"
                                    onChange={(e) => handlePersonalForm(e)} value={formData.island_1}
                                />
                                <CustomInput name="island_2" placeholder="Enter" type="text"
                                    onChange={(e) => handlePersonalForm(e)} value={formData.island_2}
                                />
                                <CustomInput name="island_3" placeholder="Enter" type="text"
                                    onChange={(e) => handlePersonalForm(e)} value={formData.island_3}
                                />
                                <CustomInput name="island_4" placeholder="Enter" type="text"
                                    onChange={(e) => handlePersonalForm(e)} value={formData.island_4}
                                />
                                <CustomInput name="island_5" placeholder="Enter" type="text"
                                    onChange={(e) => handlePersonalForm(e)} value={formData.island_5}
                                />
                            </div>
                        </div>
                        {/* Duration */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-center">
                            <div className="creatNewOffer_label text-left "><label htmlFor="">Duration</label></div>
                            <div className="profile-inputs-wrapper w-md-25 w-100">
                                <CustomInput name="duration" placeholder="Enter"
                                    type="number"
                                    onChange={(e) => handlePersonalForm(e)} value={formData.duration}
                                />
                            </div>
                            <span className="d-md-flex d-none">&nbsp; Day</span>
                        </div>
                        {/* Number of guest */}
                        <div className="main-input mb-3 mt-1 d-flex my-1 justify-content-start align-items-center mb-0 mb-2">
                            <div className="creatNewOffer_label text-left "><label htmlFor="" className="">Number of guests</label></div>
                            <div className="profile-inputs-wrapper d-flex align-items-center">
                                <span className="cursor-pointer user-select-none" onClick={() => { setFormData({ ...formData, guests: formData.guests - 1 > 0 ? formData.guests - 1 : 1 }) }}>
                                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                                        <path fillRule="evenodd" clipRule="evenodd" d="M14 0C6.26818 0 0 6.26818 0 14C0 21.7318 6.26818 28 14 28C21.7318 28 28 21.7318 28 14C28 6.26818 21.7318 0 14 0ZM8.90909 12.7273C8.57154 12.7273 8.24782 12.8614 8.00914 13.1C7.77045 13.3387 7.63636 13.6625 7.63636 14C7.63636 14.3375 7.77045 14.6613 8.00914 14.9C8.24782 15.1386 8.57154 15.2727 8.90909 15.2727H19.0909C19.4285 15.2727 19.7522 15.1386 19.9909 14.9C20.2295 14.6613 20.3636 14.3375 20.3636 14C20.3636 13.6625 20.2295 13.3387 19.9909 13.1C19.7522 12.8614 19.4285 12.7273 19.0909 12.7273H8.90909Z"
                                            fill={formData.guests - 1 > 0 ? "#1A4D6D" : "#000"}
                                        />
                                    </svg>
                                </span>
                                <div className="guest_count_box">
                                    {formData.guests > 9 ? formData.guests : "0" + formData.guests}
                                </div>
                                <span className="cursor-pointer user-select-none" onClick={() => { setFormData({ ...formData, guests: formData.guests + 1 }) }}>
                                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none">
                                        <path d="M14 0C6.26875 0 0 6.26875 0 14C0 21.7312 6.26875 28 14 28C21.7312 28 28 21.7312 28 14C28 6.26875 21.7312 0 14 0ZM20 14.75C20 14.8875 19.8875 15 19.75 15H15V19.75C15 19.8875 14.8875 20 14.75 20H13.25C13.1125 20 13 19.8875 13 19.75V15H8.25C8.1125 15 8 14.8875 8 14.75V13.25C8 13.1125 8.1125 13 8.25 13H13V8.25C13 8.1125 13.1125 8 13.25 8H14.75C14.8875 8 15 8.1125 15 8.25V13H19.75C19.8875 13 20 13.1125 20 13.25V14.75Z" fill="#1A4D6D" />
                                    </svg>
                                </span>
                            </div>
                        </div>
                        {/* Price */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-center mt-md-0 pt-md-0 pt-3">
                            <div className="creatNewOffer_label text-left ">
                                <label htmlFor="">Price</label>
                                <span className="d-md-none d-inline">&nbsp; €</span>
                            </div>
                            <div className="profile-inputs-wrapper w-md-25">
                                <CustomInput name="price" placeholder="Enter"
                                    type="number"
                                    onChange={(e) => handlePersonalForm(e)} value={formData.price}
                                />
                            </div>
                            <span className="d-md-flex d-none">&nbsp; €</span>
                        </div>
                        {/* boat_beds  */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-center mt-md-0 pt-md-0 pt-3">
                            <div className="creatNewOffer_label text-left ">
                                <label htmlFor="boat_beds ">Bedrooms</label>
                            </div>
                            <div className="profile-inputs-wrapper w-md-25">
                                <CustomInput name="boat_beds" placeholder="Enter"
                                    type="number"
                                    onChange={(e) => handlePersonalForm(e)} value={formData.boat_beds}
                                />
                            </div>
                        </div>
                        {/* boat_bathrooms   */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-center mt-md-0 pt-md-0 pt-3">
                            <div className="creatNewOffer_label text-left ">
                                <label htmlFor="boat_bathrooms">Bathrooms</label>
                            </div>
                            <div className="profile-inputs-wrapper w-md-25">
                                <CustomInput name="boat_bathrooms" placeholder="Enter"
                                    type="number"
                                    onChange={(e) => handlePersonalForm(e)} value={formData.boat_bathrooms}
                                />
                            </div>
                        </div>
                        {/* boat_length    */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-center mt-md-0 pt-md-0 pt-3">
                            <div className="creatNewOffer_label text-left ">
                                <label htmlFor="boat_length">Boat Length</label>
                            </div>
                            <div className="profile-inputs-wrapper w-md-25">
                                <CustomInput name="boat_length" placeholder="Enter"
                                    type="number"
                                    onChange={(e) => handlePersonalForm(e)} value={formData.boat_length}
                                />
                            </div>
                        </div>
                        
                        {/* Availability Dates */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-center">
                            <div className="creatNewOffer_label text-left "><label htmlFor="">Availability Dates</label></div>
                            <div className="profile-inputs-wrapper createNewOffer_availableDate_input">
                                <CustomInput
                                    onClick={() => setPickupCalendar(prev => !prev)}
                                    readOnly
                                    start_icon={<svg onClick={() => setPickupCalendar(true)} width="26" height="28" viewBox="0 0 26 28" fill="none" className="cursor-pointer">
                                        <path d="M17.7095 3.15734e-06C18.3039 -0.00139297 18.7739 0.460376 18.7752 1.07607L18.7766 2.12554C22.6331 2.42779 25.1806 5.05567 25.1848 9.08565L25.2 20.8817C25.2055 25.2755 22.4451 27.979 18.0205 27.986L7.21264 28C2.81568 28.0056 0.0207525 25.2378 0.0152234 20.8314L9.27835e-06 9.17381C-0.00551045 5.11724 2.45215 2.49636 6.30865 2.14233L6.30726 1.09286C6.30588 0.477167 6.76203 0.0139993 7.37022 0.0139993C7.97842 0.0126 8.43456 0.474369 8.43594 1.09006L8.43732 2.06957L16.6479 2.05837L16.6466 1.07887C16.6452 0.463174 17.1013 0.00140563 17.7095 3.15734e-06ZM18.2735 19.8686H18.2597C17.6238 19.884 17.1138 20.4172 17.1276 21.0609C17.129 21.7045 17.6418 22.2349 18.2776 22.2489C18.9259 22.2475 19.4512 21.7143 19.4498 21.0567C19.4498 20.399 18.9231 19.8686 18.2735 19.8686ZM6.88367 19.87C6.24783 19.898 5.75021 20.4312 5.75159 21.0748C5.78062 21.7185 6.30588 22.2223 6.94172 22.1929C7.56512 22.1649 8.06135 21.6318 8.03232 20.9881C8.0185 20.3584 7.50568 19.8686 6.88367 19.87ZM12.5786 19.863C11.9427 19.8924 11.4465 20.4242 11.4465 21.0678C11.4755 21.7115 12.0008 22.2139 12.6366 22.1859C13.2586 22.1565 13.7563 21.6248 13.7272 20.9797C13.7134 20.3514 13.2006 19.8617 12.5786 19.863ZM6.87676 14.8326C6.24092 14.8606 5.74469 15.3937 5.74606 16.0374C5.77371 16.681 6.30035 17.1848 6.93619 17.1554C7.55821 17.1274 8.05444 16.5943 8.02541 15.9506C8.01159 15.3209 7.50015 14.8312 6.87676 14.8326ZM12.573 14.7836C11.9372 14.8116 11.4396 15.3447 11.441 15.9884C11.4686 16.6321 11.9953 17.1344 12.6311 17.1064C13.2531 17.077 13.7493 16.5453 13.7217 15.9016C13.7065 15.272 13.1951 14.7822 12.573 14.7836ZM18.2679 14.7906C17.6321 14.8046 17.1345 15.3223 17.1359 15.966V15.9814C17.1497 16.6251 17.675 17.1134 18.3122 17.0994C18.9342 17.084 19.4304 16.5509 19.4166 15.9072C19.3876 15.2915 18.8886 14.7892 18.2679 14.7906ZM16.6507 4.21329L8.44009 4.22449L8.44147 5.35652C8.44147 5.95962 7.98671 6.43538 7.37851 6.43538C6.77032 6.43678 6.31279 5.96242 6.31279 5.35932L6.31141 4.28186C3.61601 4.55192 2.12455 6.13593 2.12869 9.17101L2.13008 9.60619L23.0575 9.57821V9.08845C22.998 6.07996 21.4886 4.50155 18.7794 4.26647L18.7808 5.34393C18.7808 5.94563 18.3122 6.42279 17.7178 6.42279C17.1096 6.42419 16.6521 5.94842 16.6521 5.34673L16.6507 4.21329Z" fill="#3F8BBF" />
                                    </svg>
                                    }
                                    type="text"
                                    name="date"
                                    value={
                                        dateState[0].startDate?.toString() && dateState[0].endDate?.toString() ?
                                            Moment(dateState[0].startDate?.toString()).format("Do/MM/YYYY") + " " +
                                            " to " + Moment(dateState[0].endDate?.toString()).format("Do/MM/YYYY")
                                            : ''
                                    }
                                    placeholder="mm/dd/yyyy"
                                    className="text-center text-sec"
                                />
                            </div>
                        </div>
                    </div>
                    {/* Calendar Model pickup date*/}
                    <CustomModel
                        openPopup={pickupDateModal}
                        setOpenPopup={setPickupCalendar}
                    >
                        <div className="date_menu cs_cal">
                            <div className="intradaycalender">
                                {/* <Calendar
                                    onChange={(item) => {
                                        setFormData({
                                            ...formData,
                                            pickup_date: item
                                        });
                                        setPickupCalendar(false)
                                    }}
                                    date={formData.pickup_date}
                                /> */}
                                <DateRangePicker

                                    ranges={dateState}
                                    onChange={(item) => {
                                        setDateState([item.selection]);

                                    }}
                                    selectsStart={true}
                                    // selected={startDate}
                                    // startDate={startDate}
                                    // endDate={endDate}
                                    inline={true}

                                // showRightSide={false}
                                // editableDateInputs={true}
                                // showMonthAndYearPickers={false}
                                // weekdayDisplayFormat="iii"
                                />
                            </div>
                        </div>
                    </CustomModel>

                    {/*  */}
                    <div className="col-12">
                        {/* Brief Description */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-start">
                            <div className="creatNewOffer_label text-left mt-1"><label htmlFor="">Brief Description</label></div>
                            <div className="profile-inputs-wrapper">
                                <div className="boat-desc-wrappper mid-height mt-1 p-0">
                                    <textarea
                                        onChange={(e) => setFormData({
                                            ...formData,
                                            brief_description: e.target.value
                                        })}
                                        value={formData.brief_description}
                                        placeholder="Enter here..."
                                        name="brief_description"
                                        className="m-0 border"
                                    />
                                    <div className="boat-desc-count d-flex justify-content-end align-items-center mt-1">
                                        <span className="fw-bold">{formData?.brief_description?.trim().length}/2500</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* General Description */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-start mt-2">
                            <div className="creatNewOffer_label text-left mt-1"><label htmlFor="">General Description</label></div>
                            <div className="profile-inputs-wrapper">
                                <div className="boat-desc-wrappper mid-height mt-1 p-0">
                                    <textarea
                                        onChange={(e) => setFormData({
                                            ...formData,
                                            general_description: e.target.value
                                        })}
                                        value={formData.general_description}
                                        placeholder="Enter here..."
                                        name="general_description"
                                        className="m-0 border"
                                    />
                                    <div className="boat-desc-count d-flex justify-content-end align-items-center mt-1">
                                        <span className="fw-bold">{formData?.general_description?.trim().length}/2500</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* Amenities  */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-start mt-2">
                            <div className="creatNewOffer_label text-left "><label htmlFor="">Amenities</label></div>
                            <div className="profile-inputs-wrapper creatNewOffer_extras_input flex-wrap">
                                <CustomInput name="amenities" placeholder="Enter" type="text"
                                    onChange={(e) => handlePersonalForm(e)} value={formData.amenities}
                                />
                            </div>
                        </div>
                        {/* Extras  */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-start">
                            <div className="creatNewOffer_label text-left "><label htmlFor="">Extras</label></div>
                            <div className="profile-inputs-wrapper creatNewOffer_extras_input flex-wrap">
                                <CustomInput name="extras" placeholder="Enter" type="text"
                                    onChange={(e) => handlePersonalForm(e)} value={formData.extras}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {/*====== other Activities =========== */}
                <div className="fw-bold mt-4 mb-2">
                    <span>- Activities</span>
                </div>
                {/* Activity 1 */}
                <div className="row m-0 p-2">
                    <div className="createNewOffer_activity_left">
                        <div className="d-flex justify-content-between align-items-center newOffer_activity_title">
                            <span className="fw-bold">First activity</span>
                            <span className="">
                                <div className="cs-switch-container">
                                    <label className="cs-switch cs-switch-v2" htmlFor="fistActivity">
                                        <input checked={formData.firstActivity}
                                            onChange={(e) => setFormData({ ...formData, firstActivity: e.target.checked })}
                                            className="switch-checkbox" type="checkbox" id="fistActivity" />
                                        <div className="cs-switch-slider switch-round"></div>
                                    </label>
                                </div>
                            </span>
                        </div>
                        {/* <PickImageBtn
                            num={1}
                            template2
                            loading={false}
                            selectImg={(e) => { selectNewImg(e, 'first_activity_img') }}
                            deleteImage={(e) => { removeSelectedImg(e, 'first_activity_img') }}
                            imgSrc={formData?.first_activity_img?.file}
                            srcAvail={typeof formData?.first_activity_img?.file === "string" ? true : false}
                        /> */}
                        <StaticImageBtn
                            formData={formData}
                            setImgModal={setImgModal}
                            setSelectedImgFromGallery={setSelectedImgFromGallery}
                            type="first_activity_img"
                            removeSelectedImg={removeSelectedImg}
                        />
                    </div>
                    <div className="createNewOffer_activity_right pt-4">
                        {/* boat title */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-center">
                            <div className="creatNewOffer_activity_label text-left "><label htmlFor="">Boat Title</label></div>
                            <div className="profile-inputs-wrapper">
                                <CustomInput name="activity_title_1" placeholder="Enter" type="text"
                                    onChange={(e) => handlePersonalForm(e)} value={formData.activity_title_1}
                                />

                            </div>
                        </div>
                        {/* boat Description */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-start">
                            <div className="creatNewOffer_activity_label text-left mt-1"><label htmlFor="">Boat Description</label></div>
                            <div className="profile-inputs-wrapper">
                                <div className="boat-desc-wrappper mid-height mt-1 p-0">
                                    <textarea
                                        onChange={(e) => setFormData({
                                            ...formData,
                                            first_description: e.target.value
                                        })}
                                        value={formData.first_description}
                                        placeholder="Describe here..."
                                        name="first_description"
                                        className="m-0 border"
                                    />
                                    <div className="boat-desc-count d-flex justify-content-end align-items-center mt-1">
                                        <span className="fw-bold">{formData?.first_description?.trim().length}/500</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Activity 2 */}
                <div className="row m-0 p-2">
                    <div className="createNewOffer_activity_left">
                        <div className="d-flex justify-content-between align-items-center newOffer_activity_title">
                            <span className="fw-bold">Second activity</span>
                            <span className="">
                                <div className="cs-switch-container">
                                    <label className="cs-switch cs-switch-v2" htmlFor="secondActivity">
                                        <input checked={formData.secondActivity}
                                            onChange={(e) => setFormData({ ...formData, secondActivity: e.target.checked })}
                                            className="switch-checkbox" type="checkbox" id="secondActivity" />
                                        <div className="cs-switch-slider switch-round"></div>
                                    </label>
                                </div>
                            </span>
                        </div>
                        {/* <PickImageBtn
                            num={2}
                            template2
                            loading={false}
                            selectImg={(e) => { selectNewImg(e, 'second_activity_img') }}
                            deleteImage={(e) => { removeSelectedImg(e, 'second_activity_img') }}
                            imgSrc={formData?.second_activity_img?.file}
                            srcAvail={typeof formData?.second_activity_img?.file === "string" ? true : false}
                        /> */}
                        <StaticImageBtn
                            formData={formData}
                            setImgModal={setImgModal}
                            setSelectedImgFromGallery={setSelectedImgFromGallery}
                            type="second_activity_img"
                            removeSelectedImg={removeSelectedImg}
                        />
                    </div>
                    <div className="createNewOffer_activity_right pt-4">
                        {/* boat title */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-center">
                            <div className="creatNewOffer_activity_label text-left "><label htmlFor="">Boat Title</label></div>
                            <div className="profile-inputs-wrapper">
                                <CustomInput name="activity_title_2" placeholder="Enter" type="text"
                                    onChange={(e) => handlePersonalForm(e)} value={formData.activity_title_2}
                                />

                            </div>
                        </div>
                        {/* boat Description */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-start">
                            <div className="creatNewOffer_activity_label text-left mt-1"><label htmlFor="">Boat Description</label></div>
                            <div className="profile-inputs-wrapper">
                                <div className="boat-desc-wrappper mid-height mt-1 p-0">
                                    <textarea
                                        onChange={(e) => setFormData({
                                            ...formData,
                                            second_description: e.target.value
                                        })}
                                        value={formData.second_description}
                                        placeholder="Describe here..."
                                        name="second_description"
                                        className="m-0 border"
                                    />
                                    <div className="boat-desc-count d-flex justify-content-end align-items-center mt-1">
                                        <span className="fw-bold">{formData?.second_description?.trim().length}/500</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/*=========  All Inclusive package ========== */}
                <div className="fw-bold mt-4 mb-2">
                    <span>- All Inclusive package</span>
                </div>
                {/* === yacht  === */}
                <div className="row m-0 p-2">
                    <div className="createNewOffer_activity_left">
                        <div className="d-flex mb-2 justify-content-between align-items-center newOffer_activity_title">
                            <span className="fw-bold">Yacht</span>
                            <span className="fw-bold text-pr">
                                {/* <div className="cs-switch-container">
                                    <label className="cs-switch cs-switch-v2" htmlFor="yacht">
                                        <input checked={formData.yacht}
                                            onChange={(e) => setFormData({ ...formData, yacht: e.target.checked })}
                                            className="switch-checkbox" type="checkbox" id="yacht" />
                                        <div className="cs-switch-slider switch-round"></div>
                                    </label>
                                </div> */}
                                ({Object.keys(formData?.boat_img).length})
                            </span>
                        </div>
                        <button
                            disabled={Object.values(formData?.boat_img).length < 15 ? false : true}
                            onClick={addNewButton}
                        >Add +</button>
                        <div className="d-flex flex-wrap align-items-center">
                            {Object.values(formData?.boat_img)?.map((v, i) => (
                                <StaticImageBtn
                                    key={i}
                                    formData={v}
                                    setImgModal={setImgModal}
                                    setSelectedImgFromGallery={setSelectedImgFromGallery}
                                    type={v.id}
                                    multiples
                                    removeSelectedImg={removeSelectedImg}
                                    deleteSelectedImageFromArray={deleteSelectedImageFromArray}
                                    lastItem={i === 0}
                                />
                            ))}
                        </div>
                    </div>
                    <div className="createNewOffer_activity_right pt-4">
                        {/* boat title */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-center">
                            <div className="creatNewOffer_activity_label text-left "><label htmlFor="">Boat Title</label></div>
                            <div className="profile-inputs-wrapper">
                                <CustomInput name="yacht_title" placeholder="Enter" type="text"
                                    onChange={(e) => handlePersonalForm(e)} value={formData.yacht_title}
                                />
                            </div>
                        </div>
                        {/* Location */}
                        {/* <div className="main-input d-flex my-1 justify-content-start align-items-center no_in_used">
                            <div className="creatNewOffer_activity_label text-left "><label htmlFor="">Location</label></div>
                            <div className="profile-inputs-wrapper">
                                <CustomInput name="boat_name" placeholder="Enter" type="text"
                                // onChange={(e)=> handlePersonalForm(e)} value={formData.first_name} 
                                />
                            </div>
                        </div> */}
                        {/* boat Description */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-start">
                            <div className="creatNewOffer_activity_label text-left mt-1"><label htmlFor="">Description</label></div>
                            <div className="profile-inputs-wrapper">
                                <div className="boat-desc-wrappper mid-height mt-1 p-0">
                                    <textarea
                                        onChange={(e) => setFormData({
                                            ...formData,
                                            yacht_description: e.target.value
                                        })}
                                        value={formData.yacht_description}
                                        placeholder="Describe here..."
                                        name="yacht_description"
                                        className="m-0 border"
                                    />
                                    <div className="boat-desc-count d-flex justify-content-end align-items-center mt-1">
                                        <span className="fw-bold">{formData?.yacht_description?.trim().length}/2500</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* ==== Hotel === */}
                {/* <div className="row m-0 p-2 no_in_used">
                    <div className="createNewOffer_activity_left">
                        <div className="d-flex justify-content-between align-items-center newOffer_activity_title">
                            <span className="fw-bold">Hotel</span>
                            <span className="">
                                <div className="cs-switch-container">
                                    <label className="cs-switch cs-switch-v2" htmlFor="hotel">
                                        <input checked={formData.hotel}
                                            onChange={(e) => setFormData({ ...formData, hotel: e.target.checked })}
                                            className="switch-checkbox" type="checkbox" id="hotel" />
                                        <div className="cs-switch-slider switch-round"></div>
                                    </label>
                                </div>
                            </span>
                        </div>
                        <PickImageBtn
                            template2
                            loading={false}
                            selectImg={(e) => { console.log(e) }}
                            deleteImage={null}
                            imgSrc={""}
                            srcAvail={false}
                        />
                    </div>
                    <div className="createNewOffer_activity_right pt-4">
                        <div className="main-input d-flex my-1 justify-content-start align-items-center">
                            <div className="creatNewOffer_activity_label text-left "><label htmlFor="">Hotel Title</label></div>
                            <div className="profile-inputs-wrapper">
                                <CustomInput name="boat_name" placeholder="Enter" type="text"
                                // onChange={(e)=> handlePersonalForm(e)} value={formData.first_name} 
                                />

                            </div>
                        </div>
                        <div className="main-input d-flex my-1 justify-content-start align-items-center">
                            <div className="creatNewOffer_activity_label text-left "><label htmlFor="">Location</label></div>
                            <div className="profile-inputs-wrapper">
                                <CustomInput name="boat_name" placeholder="Enter" type="text"
                                // onChange={(e)=> handlePersonalForm(e)} value={formData.first_name} 
                                />

                            </div>
                        </div>
                        <div className="main-input d-flex my-1 justify-content-start align-items-start">
                            <div className="creatNewOffer_activity_label text-left mt-1"><label htmlFor="">Description</label></div>
                            <div className="profile-inputs-wrapper">
                                <div className="boat-desc-wrappper mid-height mt-1 p-0">
                                    <textarea
                                        onChange={(e) => setFormData({
                                            ...formData,
                                            hotel_description: e.target.value
                                        })}
                                        value={formData.hotel_description}
                                        placeholder="Describe here..."
                                        name="hotel_description"
                                        className="m-0 border"
                                    />
                                    <div className="boat-desc-count d-flex justify-content-end align-items-center mt-1">
                                        <span className="fw-bold">{formData?.hotel_description?.trim().length}/500</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/* ==== Transportation === */}
                <div className="row m-0 p-2">
                    <div className="createNewOffer_activity_left">
                        <div className="d-flex justify-content-between align-items-center newOffer_activity_title">
                            <span className="fw-bold">Transfer</span>
                            <span className="">
                                <div className="cs-switch-container">
                                    <label className="cs-switch cs-switch-v2" htmlFor="transfer">
                                        <input checked={formData.transfer}
                                            onChange={(e) => setFormData({ ...formData, transfer: e.target.checked })}
                                            className="switch-checkbox" type="checkbox" id="transfer" />
                                        <div className="cs-switch-slider switch-round"></div>
                                    </label>
                                </div>
                            </span>
                        </div>
                        {/* <PickImageBtn
                            num={4}
                            template2
                            loading={false}
                            selectImg={(e) => { selectNewImg(e, 'transfer_img') }}
                            deleteImage={(e) => { removeSelectedImg(e, 'transfer_img') }}
                            imgSrc={formData?.transfer_img?.file}
                            srcAvail={typeof formData?.transfer_img?.file === "string" ? true : false}
                        /> */}
                        <StaticImageBtn
                            formData={formData}
                            setImgModal={setImgModal}
                            setSelectedImgFromGallery={setSelectedImgFromGallery}
                            type="transfer_img"
                            removeSelectedImg={removeSelectedImg}
                        />
                    </div>
                    <div className="createNewOffer_activity_right pt-4">
                        {/* Transportation title */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-center">
                            <div className="creatNewOffer_activity_label text-left "><label htmlFor="">Transportation Title</label></div>
                            <div className="profile-inputs-wrapper">
                                <CustomInput name="transfer_title" placeholder="Enter" type="text"
                                    onChange={(e) => handlePersonalForm(e)} value={formData.transfer_title}
                                />

                            </div>
                        </div>
                        {/* Location */}
                        {/* <div className="main-input d-flex my-1 justify-content-start align-items-center no_in_used">
                            <div className="creatNewOffer_activity_label text-left "><label htmlFor="">Location</label></div>
                            <div className="profile-inputs-wrapper">
                                <CustomInput name="boat_name" placeholder="Enter" type="text"
                                // onChange={(e)=> handlePersonalForm(e)} value={formData.first_name} 
                                />

                            </div>
                        </div> */}
                        {/* boat Description */}
                        <div className="main-input d-flex my-1 justify-content-start align-items-start">
                            <div className="creatNewOffer_activity_label text-left mt-1"><label htmlFor="">Description</label></div>
                            <div className="profile-inputs-wrapper">
                                <div className="boat-desc-wrappper mid-height mt-1 p-0">
                                    <textarea
                                        onChange={(e) => setFormData({
                                            ...formData,
                                            transfer_description: e.target.value
                                        })}
                                        value={formData.transfer_description}
                                        placeholder="Describe here..."
                                        name="transfer_description"
                                        className="m-0 border"
                                    />
                                    <div className="boat-desc-count d-flex justify-content-end align-items-center mt-1">
                                        <span className="fw-bold">{formData?.transfer_description?.trim().length}/500</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* ==== Restaurant === */}
                {/* <div className="row m-0 p-2 no_in_used">
                    <div className="createNewOffer_activity_left">
                        <div className="d-flex justify-content-between align-items-center newOffer_activity_title">
                            <span className="fw-bold">Restaurant</span>
                            <span className="">
                                <div className="cs-switch-container">
                                    <label className="cs-switch cs-switch-v2" htmlFor="restaurant">
                                        <input checked={formData.restaurant}
                                            onChange={(e) => setFormData({ ...formData, restaurant: e.target.checked })}
                                            className="switch-checkbox" type="checkbox" id="restaurant" />
                                        <div className="cs-switch-slider switch-round"></div>
                                    </label>
                                </div>
                            </span>
                        </div>
                        <PickImageBtn
                            template2
                            loading={false}
                            selectImg={(e) => { console.log(e) }}
                            deleteImage={null}
                            imgSrc={""}
                            srcAvail={false}
                        />
                    </div>
                    <div className="createNewOffer_activity_right pt-4">
                        <div className="main-input d-flex my-1 justify-content-start align-items-center">
                            <div className="creatNewOffer_activity_label text-left "><label htmlFor="">Location</label></div>
                            <div className="profile-inputs-wrapper">
                                <CustomInput name="boat_name" placeholder="Enter"
                                    type="text"
                                // onChange={(e)=> handlePersonalForm(e)} value={formData.first_name} 
                                />
                            </div>
                        </div>
                        <div className="main-input d-flex my-1 justify-content-start align-items-start">
                            <div className="creatNewOffer_activity_label text-left mt-1"><label htmlFor="">Description</label></div>
                            <div className="profile-inputs-wrapper">
                                <div className="boat-desc-wrappper mid-height mt-1 p-0">
                                    <textarea
                                        onChange={(e) => setFormData({
                                            ...formData,
                                            location_description: e.target.value
                                        })}
                                        value={formData.location_description}
                                        placeholder="Describe here..."
                                        name="location_description"
                                        className="m-0 border"
                                    />
                                    <div className="boat-desc-count d-flex justify-content-end align-items-center mt-1">
                                        <span className="fw-bold">{formData?.location_description?.trim().length}/500</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}
                {/*====== other Activities =========== */}
                <div className="fw-bold mt-4 mb-2">
                    <span>- Offer Availability</span>
                </div>
                <div className="d-flex justify-content-start align-items-center px-3 mt-2">
                    <span className="text-sec fw-bold">Is the Package visible? &nbsp;</span>
                    <span className="px-2">
                        <div className="cs-switch-container ">
                            <label className="cs-switch cs-switch-v2" htmlFor="offerVisible">
                                <input checked={formData.offerVisible}
                                    onChange={(e) => setFormData({ ...formData, offerVisible: e.target.checked })}
                                    className="switch-checkbox" type="checkbox" id="offerVisible" />
                                <div className="cs-switch-slider switch-round"></div>
                            </label>
                        </div>
                    </span>
                </div>
                {/* Counter */}
                <div className="py-3 px-3 creatNewOffer_counter_div">
                    <div className="main-input d-flex my-1 justify-content-start align-items-center">
                        <div className="creatNewOffer_activity_label text-left "><label htmlFor="">Counter</label></div>
                        <div className="profile-inputs-wrapper">
                            <CustomInput name="counter" placeholder="Enter"
                                type="number"
                                onChange={(e) => handlePersonalForm(e)} value={formData.counter}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

// ============ This is a static image select button only for this page =====================
const StaticImageBtn = ({
    formData, setImgModal,
    setSelectedImgFromGallery,
    type, removeSelectedImg,
    multiples,
    deleteSelectedImageFromArray,
    lastItem
}) => {

    return (
        <div className="static_img_select_btn mx-1" >
            {multiples ?
                <>
                    <div className="static_img_select_wrap"
                        onClick={() => {
                            setImgModal({ open: true, type: type, multiples: multiples });
                            setSelectedImgFromGallery(formData?.file)
                        }}
                    >
                        {formData?.isSelected ?
                            <img src={apiStart + formData?.file} alt="" />
                            :
                            <>
                                <svg width="39" height="34" viewBox="0 0 39 34" fill="none">
                                    <path d="M14.625 11.0625C14.625 12.0073 14.2497 12.9135 13.5816 13.5816C12.9135 14.2497 12.0073 14.625 11.0625 14.625C10.1177 14.625 9.21153 14.2497 8.54343 13.5816C7.87533 12.9135 7.5 12.0073 7.5 11.0625C7.5 10.1177 7.87533 9.21153 8.54343 8.54343C9.21153 7.87533 10.1177 7.5 11.0625 7.5C12.0073 7.5 12.9135 7.87533 13.5816 8.54343C14.2497 9.21153 14.625 10.1177 14.625 11.0625Z" fill="#92B9D5" />
                                    <path d="M5.125 0.375C3.86522 0.375 2.65704 0.875445 1.76624 1.76624C0.875445 2.65704 0.375 3.86522 0.375 5.125V28.875C0.375 30.1348 0.875445 31.343 1.76624 32.2338C2.65704 33.1246 3.86522 33.625 5.125 33.625H33.625C34.8848 33.625 36.093 33.1246 36.9838 32.2338C37.8746 31.343 38.375 30.1348 38.375 28.875V5.125C38.375 3.86522 37.8746 2.65704 36.9838 1.76624C36.093 0.875445 34.8848 0.375 33.625 0.375H5.125ZM33.625 2.75C34.2549 2.75 34.859 3.00022 35.3044 3.44562C35.7498 3.89102 36 4.49511 36 5.125V20.5625L27.0296 15.9384C26.8069 15.8268 26.5547 15.7881 26.3088 15.8277C26.0629 15.8674 25.8356 15.9834 25.6593 16.1593L16.848 24.9705L10.5305 20.762C10.3024 20.6101 10.0288 20.5418 9.75611 20.5687C9.4834 20.5955 9.22837 20.7158 9.03425 20.9093L2.75 26.5V5.125C2.75 4.49511 3.00022 3.89102 3.44562 3.44562C3.89102 3.00022 4.49511 2.75 5.125 2.75H33.625Z" fill="#92B9D5" />
                                </svg>
                                <svg className="choose-img-btn-camera" width="27" height="21" viewBox="0 0 27 21" fill="none">
                                    <path d="M17.8005 11.0623C17.8005 12.1682 17.3612 13.2288 16.5792 14.0108C15.7972 14.7928 14.7366 15.2321 13.6307 15.2321C12.5248 15.2321 11.4642 14.7928 10.6822 14.0108C9.90025 13.2288 9.46094 12.1682 9.46094 11.0623C9.46094 9.95645 9.90025 8.89586 10.6822 8.11387C11.4642 7.33189 12.5248 6.89258 13.6307 6.89258C14.7366 6.89258 15.7972 7.33189 16.5792 8.11387C17.3612 8.89586 17.8005 9.95645 17.8005 11.0623Z" fill="#3F8BBF" />
                                    <path d="M3.62488 3.55652C2.74016 3.55652 1.89169 3.90797 1.2661 4.53356C0.640513 5.15914 0.289063 6.00762 0.289062 6.89233L0.289063 16.8998C0.289063 17.7845 0.640513 18.633 1.2661 19.2586C1.89169 19.8841 2.74016 20.2356 3.62488 20.2356H23.6398C24.5245 20.2356 25.373 19.8841 25.9985 19.2586C26.6241 18.633 26.9756 17.7845 26.9756 16.8998V6.89233C26.9756 6.00762 26.6241 5.15914 25.9985 4.53356C25.373 3.90797 24.5245 3.55652 23.6398 3.55652H21.685C20.8003 3.55633 19.952 3.20475 19.3266 2.57912L17.9455 1.1981C17.3201 0.572467 16.4717 0.220892 15.5871 0.220703H11.6775C10.7929 0.220892 9.94455 0.572467 9.31911 1.1981L7.93809 2.57912C7.31264 3.20475 6.4643 3.55633 5.57966 3.55652H3.62488ZM4.45883 6.89233C4.23765 6.89233 4.02553 6.80447 3.86914 6.64807C3.71274 6.49168 3.62488 6.27956 3.62488 6.05838C3.62488 5.8372 3.71274 5.62508 3.86914 5.46868C4.02553 5.31229 4.23765 5.22442 4.45883 5.22442C4.68001 5.22442 4.89213 5.31229 5.04852 5.46868C5.20492 5.62508 5.29278 5.8372 5.29278 6.05838C5.29278 6.27956 5.20492 6.49168 5.04852 6.64807C4.89213 6.80447 4.68001 6.89233 4.45883 6.89233ZM19.47 11.0621C19.47 12.6103 18.855 14.0952 17.7602 15.19C16.6654 16.2847 15.1806 16.8998 13.6323 16.8998C12.0841 16.8998 10.5992 16.2847 9.50446 15.19C8.40968 14.0952 7.79465 12.6103 7.79465 11.0621C7.79465 9.51385 8.40968 8.02902 9.50446 6.93424C10.5992 5.83946 12.0841 5.22442 13.6323 5.22442C15.1806 5.22442 16.6654 5.83946 17.7602 6.93424C18.855 8.02902 19.47 9.51385 19.47 11.0621Z" fill="#3F8BBF" />
                                </svg>
                            </>}
                    </div>
                    {formData?.isSelected ?
                        <div className="remove-up-img" onClick={(e) => removeSelectedImg(e, type, multiples)}>
                            <Close />
                        </div>
                        : lastItem ? null :
                            (<div className="remove-up-img" onClick={() => deleteSelectedImageFromArray(type)}>
                                <DeleteForever />
                            </div>)
                    }

                </>
                :
                <>
                    <div className="static_img_select_wrap"
                        onClick={() => {
                            setImgModal({ open: true, type: type });
                            setSelectedImgFromGallery(formData[type]?.file)
                        }}
                    >
                        {formData[type]?.isSelected ?
                            <img src={apiStart + formData[type]?.file} alt="" />
                            :
                            <>
                                <svg width="39" height="34" viewBox="0 0 39 34" fill="none">
                                    <path d="M14.625 11.0625C14.625 12.0073 14.2497 12.9135 13.5816 13.5816C12.9135 14.2497 12.0073 14.625 11.0625 14.625C10.1177 14.625 9.21153 14.2497 8.54343 13.5816C7.87533 12.9135 7.5 12.0073 7.5 11.0625C7.5 10.1177 7.87533 9.21153 8.54343 8.54343C9.21153 7.87533 10.1177 7.5 11.0625 7.5C12.0073 7.5 12.9135 7.87533 13.5816 8.54343C14.2497 9.21153 14.625 10.1177 14.625 11.0625Z" fill="#92B9D5" />
                                    <path d="M5.125 0.375C3.86522 0.375 2.65704 0.875445 1.76624 1.76624C0.875445 2.65704 0.375 3.86522 0.375 5.125V28.875C0.375 30.1348 0.875445 31.343 1.76624 32.2338C2.65704 33.1246 3.86522 33.625 5.125 33.625H33.625C34.8848 33.625 36.093 33.1246 36.9838 32.2338C37.8746 31.343 38.375 30.1348 38.375 28.875V5.125C38.375 3.86522 37.8746 2.65704 36.9838 1.76624C36.093 0.875445 34.8848 0.375 33.625 0.375H5.125ZM33.625 2.75C34.2549 2.75 34.859 3.00022 35.3044 3.44562C35.7498 3.89102 36 4.49511 36 5.125V20.5625L27.0296 15.9384C26.8069 15.8268 26.5547 15.7881 26.3088 15.8277C26.0629 15.8674 25.8356 15.9834 25.6593 16.1593L16.848 24.9705L10.5305 20.762C10.3024 20.6101 10.0288 20.5418 9.75611 20.5687C9.4834 20.5955 9.22837 20.7158 9.03425 20.9093L2.75 26.5V5.125C2.75 4.49511 3.00022 3.89102 3.44562 3.44562C3.89102 3.00022 4.49511 2.75 5.125 2.75H33.625Z" fill="#92B9D5" />
                                </svg>
                                <svg className="choose-img-btn-camera" width="27" height="21" viewBox="0 0 27 21" fill="none">
                                    <path d="M17.8005 11.0623C17.8005 12.1682 17.3612 13.2288 16.5792 14.0108C15.7972 14.7928 14.7366 15.2321 13.6307 15.2321C12.5248 15.2321 11.4642 14.7928 10.6822 14.0108C9.90025 13.2288 9.46094 12.1682 9.46094 11.0623C9.46094 9.95645 9.90025 8.89586 10.6822 8.11387C11.4642 7.33189 12.5248 6.89258 13.6307 6.89258C14.7366 6.89258 15.7972 7.33189 16.5792 8.11387C17.3612 8.89586 17.8005 9.95645 17.8005 11.0623Z" fill="#3F8BBF" />
                                    <path d="M3.62488 3.55652C2.74016 3.55652 1.89169 3.90797 1.2661 4.53356C0.640513 5.15914 0.289063 6.00762 0.289062 6.89233L0.289063 16.8998C0.289063 17.7845 0.640513 18.633 1.2661 19.2586C1.89169 19.8841 2.74016 20.2356 3.62488 20.2356H23.6398C24.5245 20.2356 25.373 19.8841 25.9985 19.2586C26.6241 18.633 26.9756 17.7845 26.9756 16.8998V6.89233C26.9756 6.00762 26.6241 5.15914 25.9985 4.53356C25.373 3.90797 24.5245 3.55652 23.6398 3.55652H21.685C20.8003 3.55633 19.952 3.20475 19.3266 2.57912L17.9455 1.1981C17.3201 0.572467 16.4717 0.220892 15.5871 0.220703H11.6775C10.7929 0.220892 9.94455 0.572467 9.31911 1.1981L7.93809 2.57912C7.31264 3.20475 6.4643 3.55633 5.57966 3.55652H3.62488ZM4.45883 6.89233C4.23765 6.89233 4.02553 6.80447 3.86914 6.64807C3.71274 6.49168 3.62488 6.27956 3.62488 6.05838C3.62488 5.8372 3.71274 5.62508 3.86914 5.46868C4.02553 5.31229 4.23765 5.22442 4.45883 5.22442C4.68001 5.22442 4.89213 5.31229 5.04852 5.46868C5.20492 5.62508 5.29278 5.8372 5.29278 6.05838C5.29278 6.27956 5.20492 6.49168 5.04852 6.64807C4.89213 6.80447 4.68001 6.89233 4.45883 6.89233ZM19.47 11.0621C19.47 12.6103 18.855 14.0952 17.7602 15.19C16.6654 16.2847 15.1806 16.8998 13.6323 16.8998C12.0841 16.8998 10.5992 16.2847 9.50446 15.19C8.40968 14.0952 7.79465 12.6103 7.79465 11.0621C7.79465 9.51385 8.40968 8.02902 9.50446 6.93424C10.5992 5.83946 12.0841 5.22442 13.6323 5.22442C15.1806 5.22442 16.6654 5.83946 17.7602 6.93424C18.855 8.02902 19.47 9.51385 19.47 11.0621Z" fill="#3F8BBF" />
                                </svg>
                            </>}
                    </div>
                    {formData[type]?.isSelected && <div className="remove-up-img" onClick={(e) => removeSelectedImg(e, type)}><Close /></div>}
                </>}
        </div>
    )
}


export default AddNew;

